module.exports = __webpack_public_path__ + "img/copy_check.fe4d34eb.svg";